import { useLazyQuery } from "@apollo/client";
import { useState, useCallback, useEffect } from "react";
import { GET_ROLE_DETAIL } from "../../../graphql/position-gql";
import { IPosition } from "../../../types/position";
import CollapsablePanel from "../../common/collapsable-panel/collapsable-panel";
import { AddIcon, DeleteIcon } from "../../common/icons";
import RoleInformation from "./role-information/role-information";
import AssignedIndividual from "./assigned-individual/assigned-individual";
import AssignIndividualModal from "../../position/position-detail/assign-individual/assign-individual";
import useToggle from "../../../hook/useToggle";
import useAuth from "../../../hook/useAuth";
import Button from "../../common/button";

type RoleDetailProps = {
    role: IPosition;
    updateSelectedRole?:(updatedRole:IPosition)=>void
}

const RoleDetails = (props: RoleDetailProps) => {
    const {role,updateSelectedRole} = props
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false)
    const { isOpen : isAssignOpen, toggle : assignToggle } = useToggle()
    const [roleDetail,setRoleDetail] = useState<IPosition>()
    const toggleDropdownOpen = useCallback(() => {setDropdownOpen(!dropdownOpen)}, [dropdownOpen])
    const [expirable,setExpirable] = useState<boolean>(false);
    const [getRoleDetail,{ data:roleDetailData }]= useLazyQuery(GET_ROLE_DETAIL);
    const { isAdmin,isCoordinator } = useAuth()
    
    useEffect(()=>{
        getRoleDetail({variables:{roleId:role.positionId},fetchPolicy: "network-only"});
        
    },[role,getRoleDetail])

    useEffect(()=>{
        
        if(roleDetailData?.role)
            setRoleDetail(roleDetailData?.role)
    },[roleDetailData])
    
    const onExpireRole = ()=>{}
    
    return (
        <div>
            {roleDetailData?.role&&<AssignIndividualModal position={roleDetailData.role} isOpen={isAssignOpen} toggle={assignToggle}/>}
            {(isAdmin || isCoordinator) && <Button color="primary" style={{ marginRight: '15px' }} onClick={assignToggle} >
                <AddIcon />
                &nbsp;Assign
            </Button>
            }
            {/*(isAdmin || isCoordinator) && <><Button color="danger" style={{ marginRight: '15px' }} onClick={onExpireRole} disabled={!expirable}>
                <DeleteIcon/> Expire Role
            </Button>
           
            </>
            */}
             <br />
             <br />
            {roleDetail &&<>
            <CollapsablePanel headTitle="Role Information" initCollapse={false} helpUrl="">
                <RoleInformation  role={roleDetail} updateSelectedRole={updateSelectedRole} />
            </CollapsablePanel>
            <br />
            <CollapsablePanel headTitle="Assigned Individual" initCollapse={false} helpUrl="">
                <AssignedIndividual role={roleDetail} />
            </CollapsablePanel>
            </>}

        </div>
    )
}

export default RoleDetails;
